export default __webpack_public_path__ + "static/media/GothamRounded-Bold.a829ff15.otf";